import * as React from 'react'
import { ActionButton } from 'uiComponents/buttons'
import { DisabledItemHoverInfotip } from 'uiComponents/infotip'
import { useTranslation } from 'translations'

interface SaveAreaProps {
    label: string
    disabledReason: string | null
    confirming: boolean
    confirmText: string
    busy: boolean
    onSave: () => void
    onConfirm: () => void
    onKeepEditing: () => void
}

export function SaveArea({
    label,
    disabledReason,
    confirming,
    confirmText,
    busy,
    onSave,
    onConfirm,
    onKeepEditing,
}: SaveAreaProps) {
    const { t } = useTranslation()
    return (
        <div className="capacity-save-area">
            {confirming ? (
                <>
                    <p className="capacity-confirm-text">{confirmText}</p>
                    <ActionButton type="button" size="large" secondary onClick={onKeepEditing} disabled={busy}>
                        {t('capacity.save.keepEditing')}
                    </ActionButton>
                    <ActionButton type="button" size="large" onClick={onConfirm} disabled={busy}>
                        {busy ? t('capacity.save.saving') : t('capacity.save.confirm')}
                    </ActionButton>
                </>
            ) : disabledReason ? (
                <DisabledItemHoverInfotip active infotipText={disabledReason} width="22em" bottom toTheLeft>
                    <ActionButton type="button" size="large" disabled>
                        {label}
                    </ActionButton>
                </DisabledItemHoverInfotip>
            ) : (
                <ActionButton type="button" size="large" onClick={onSave}>
                    {label}
                </ActionButton>
            )}
        </div>
    )
}
